import { useState } from "react"

import { Divider, Flex, Typography } from "antd"
import classname from "classname"
import { useSelector } from "react-redux"

import Private from "../../../../../Components/Private"
import Icon from "../../../../../Icon"
import AppUtils from "../../../../../Utils/utils"
import { descriptorStatusTextMap, descriptorStatusTypeMap } from "../../../utils/Enrollment.util"
import DescriptorLogs from "../DescriptorLogs/DescriptorLogs"
import DescriptorStatusText from "../DescriptorStatusText/DescriptorStatusText"
import StatusScale from "../StatusScale/StatusScale"

import "./DescriptorListItem.less"

const { Text } = Typography

const DescriptorListItem = ({ descriptor, service, withoutLogs, headerAddon = "" }) => {
  const { is_demo } = useSelector((state) => state.auth.userInfo)
  const isAdmin = useSelector((state) => state.auth.isAdmin)

  const name = descriptor?.billing_descriptor
  const status = descriptor?.current_status
  const descriptorType = descriptor?.descriptor_type || "Exact Match"
  const enrollmentStartDate = descriptor?.enrollment_start_date ?? new Date()
  const lastStatusChangeDate = descriptor?.last_status_change_date ?? new Date()
  const previousStatus = descriptor?.previous_status

  const date = descriptor?.enrollment_start_date ?? new Date()
  const logs = descriptor?.logs
  const [isCopied, setIsCopied] = useState(false)

  const copyName = () => {
    AppUtils.copyToClipboard(name)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 1500)
  }

  return (
    <Flex gap={8} vertical className="descriptor-list-item">
      <Flex justify="space-between" align="center" style={{ overflow: "hidden" }} gap={20}>
        <Flex gap={8} align="center" style={{ overflow: "hidden" }}>
          <button type="button" className="descriptor-copy-btn" onClick={copyName}>
            {isCopied ? <Icon type="check" /> : <Icon type="copy" />}
          </button>
          <Text strong className="descriptor-name">
            <Private>{name}</Private>
          </Text>
          {headerAddon}
          {!headerAddon && status === "active" && (
            <>
              <Text type="secondary" strong style={{ whiteSpace: "nowrap" }}>
                {descriptorType}
              </Text>
              <Divider type="vertical" style={{ margin: "0px 4px" }} />
            </>
          )}
          {!isAdmin && (
            <Text
              className={classname(
                "descriptor-status-text",
                descriptorStatusTypeMap[status] || "pending"
              )}
            >
              {descriptorStatusTextMap[status] || status}
            </Text>
          )}
        </Flex>
        {!withoutLogs && <DescriptorLogs descriptor={descriptor} service={service} />}
      </Flex>
      <StatusScale status={status} />
      <Text type="secondary" className="descriptor-caption">
        <DescriptorStatusText
          status={status}
          service={service}
          enrollmentStartDate={enrollmentStartDate}
          isBalanceToppedUp={!is_demo}
          lastStatusChangeDate={lastStatusChangeDate}
          previousStatus={previousStatus}
        />
      </Text>
    </Flex>
  )
}

export default DescriptorListItem
